import SearchBase from "@grindex-client/components/Search/search-base.class";
import FreeTextSearchQuery from "@grindex-client/components/Search/Query/free-text-search-query.class";
import { FacetsManager } from "@grindex-client/components/Search/Extensions/facets-search.class";
import DirtyManager from "@grindex-client/components/Search/Extensions/DirtyManager.class";
import SearchHeader from "@grindex-client/components/Search/Extensions/SearchHeader.class";

import { events } from "@grindex-common/helpers/events";
import { isSearchTab } from "@grindex-client/components/Search/helpers/search-tab";

export default class FreeTextSearch extends SearchBase {
	searchIndex: number | undefined;
	facetsManager: FacetsManager<FreeTextSearchQuery>;
	searchHeader: SearchHeader;
	$secondaryLoaders: any[];
	$resultTitle: any;
	constructor($ownerModule: HTMLElement, eventManager: any) {
		const query = new FreeTextSearchQuery();
		const dirtyManager = new DirtyManager();

		const $facetIds = document.querySelector("#facetids") as HTMLInputElement | null;

		if ($facetIds?.value) {
			query.queryData.isbrandproductsearch = true;
		}

		super($ownerModule, eventManager, dirtyManager, query);

		this.isApi = true;
		this.facetsManager = new FacetsManager($ownerModule, eventManager, dirtyManager, query);
		this.searchHeader = new SearchHeader($ownerModule, eventManager, query);

		this.facetsManager.initFacets();
		this.searchHeader.initHeader(this.queryObject.getPagingData().pageSize);
		const tabName = this.$module.closest<HTMLElement>(".tab-content")?.dataset["tabName"];

		if (isSearchTab(tabName)) {
			this.tab = tabName;
		}
		this.$secondaryLoaders = this.getSecondaryLoaders();
		this.$resultTitle = this.$module.querySelector(".resultsHeader");

		this.eventManager.on(this, events.search.TOGGLE_LOADER, this.toggleSecondaryLoader.bind(this));
		this.eventManager.on(this, events.search.CHANGE_PAGE_SIZE, this.onPageSizeChanged.bind(this));
		this.eventManager.on(this, events.search.RENDERED, this.facetsManager.renderCurrentFilters.bind(this.facetsManager));
		this.searchIndex = undefined;
		this.siblingTabs = undefined;
	}

	onPageSizeChanged() {
		const $selectedTab = document.querySelector<HTMLElement>(".tab_selected[data-tab]");

		if ($selectedTab === null) {
			return;
		}

		if ($selectedTab.dataset["tabId"] === this.tab) {
			this.search(true);
		}
	}

	getSecondaryLoaders() {
		const $loaders: HTMLElement[] = [];
		const $loaderContainers = document.querySelectorAll(`[data-tab-id="${this.tab}"]`);

		$loaderContainers.forEach(($loaderContainer) => {
			const $loader = $loaderContainer.querySelector("[xyl-element='loader-secondary']") as HTMLElement | null;
			if ($loader) {
				$loaders.push($loader);
			}
		});

		return $loaders;
	}

	toggleSecondaryLoader() {
		const $secondaryLoaders = this.getSecondaryLoaders();
		$secondaryLoaders.forEach(($loader) => {
			$loader.classList.toggle("hidden");
		});
	}
}
